export const SELECT_BOT = 'SELECT_BOT';

export const selectBot = (bot) => {
    return {
        type: SELECT_BOT,
        payload: bot
    }
}


// WEBPACK FOOTER //
// ./src/redux/actions/bot-select.js